document.addEventListener('DOMContentLoaded', () => {
  const buttonsDropdownWrapper = document.querySelector(
    '[data-buttons-dropdown-wrapper]',
  )
  const buttonsDropdownOpener = document.querySelector(
    '[data-buttons-dropdown-opener]',
  )

  const buttonLabels = document.querySelectorAll(
    '.image-with-tabs-overlay__dropdown-opener-text',
  )

  if (!buttonsDropdownWrapper || !buttonsDropdownOpener) {
    return
  }

  buttonsDropdownOpener.addEventListener('click', () => {
    buttonsDropdownWrapper.classList.toggle('is-open')
    buttonLabels.forEach((buttonLabel) => {
      buttonLabel.classList.toggle('hidden')
    })
  })
})
